import common from "@store/theme/common";
import * as styleguide from "@store/theme/horizon/styleguide";
import overrideProps from "@store/utilities/overrideProps";

export default overrideProps(common, styleguide);
